import React from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../UI/dropdown-menu';
import { MoreHorizontal } from 'lucide-react';
import { Button } from '../ui/button';
import ArchiveIcon from '../../assets/icons/archive.svg';
// import AddStickyNote from '../../assets/icons/add_sticky_note.svg';
// import DeleteStickyNote from '../../assets/icons/delete_sticky_note.svg';
import EyeIcon from '../../assets/icons/eye.svg';
import { FaPrint } from 'react-icons/fa';

type DotMenuCellProps = {
  row: any;
  handleGoToClient(client: any): void;
  fetchClientProjects(client: any): void;
  handleOpenConfirmModal(action: any, id?: any): void;
  disabled?: boolean;
};

const DotMenuCell = (props: DotMenuCellProps) => {
  const {
    row,
    handleGoToClient,
    fetchClientProjects,
    handleOpenConfirmModal,
    disabled = false,
  } = props;

  const client = row?.original?.client;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger data-qa={`projects_row_${row?.original?.id}_project_dots_menu_trigger`} asChild>
        <Button variant="ghost" className="h-8 w-8 p-0">
          <span className="sr-only">Open menu</span>
          <MoreHorizontal />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuGroup>
          <DropdownMenuItem
            data-qa={`projects_row_${row?.original?.id}_project_dots_menu_view_project`}
            disabled={disabled}
            onClick={() => {
              if (disabled) return;
              handleGoToClient(client);
            }}
            className="relative flex cursor-pointer select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50"
          >
            <EyeIcon className="size-5" />
            <span>View Project</span>
          </DropdownMenuItem>

          <DropdownMenuItem
            data-qa={`projects_row_${row?.original?.id}_project_dots_menu_batch_print`}
            disabled={disabled}
            onClick={async () => {
              if (disabled) return;
              await fetchClientProjects(client);
            }}
            className="relative flex cursor-pointer select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50"
          >
            <FaPrint className="size-5" fill="#3b97b1" />
            <span>Batch Print</span>
          </DropdownMenuItem>

          <DropdownMenuSeparator />

          <DropdownMenuItem
            data-qa={`projects_row_${row?.original?.id}_project_dots_menu_archive_project`}
            disabled={disabled}
            onClick={() => {
              if (disabled) return;
              handleOpenConfirmModal('archive', row?.original?.id);
            }}
            className="relative flex cursor-pointer select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50"
          >
            <ArchiveIcon className="size-5" />
            <span>Archive Project</span>
          </DropdownMenuItem>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default DotMenuCell;
